import * as React from 'react';
import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';
import { compose } from 'redux';

import TimeZoneSourceType from 'ab-enums/timezoneSourceType.enum';

import TimezoneSourceBanner from 'af-components/TimezoneSourceBanner';

import * as TimezoneActions from 'af-actions/timezone';

interface OwnProps {
	jobTimezone: Nullable<string>;
	companyTimezone: Nullable<string>;
	latitude: Nullable<number>;
	longitude: Nullable<number>;
}

type Props = OwnProps & ConnectedProps<typeof connector>;

const TimezoneHeader: React.FC<Props> = (props) => {
	const { companyTimezone, jobTimezone, latitude, longitude, findTimezone } = props;

	const [timezone, setTimezone] = React.useState<Nullable<string>>(null);
	const [timezoneSourceType, setTimezoneSourceType] = React.useState<Nullable<TimeZoneSourceType>>(null);

	React.useEffect(() => {
		const getTimezone = async () => {
			let _timezone: Nullable<string> = null;
			let _timezoneSourceType: Nullable<TimeZoneSourceType> = null;

			if ((latitude === 0 || latitude) && (longitude === 0 || longitude)) {
				const result = await findTimezone(latitude, longitude);
				_timezone = result.timezone;
				if (_timezone) {
					_timezoneSourceType = TimeZoneSourceType.WORK_ORDER;
					setTimezone(_timezone);
					setTimezoneSourceType(_timezoneSourceType);
					return;
				}
			}

			_timezone = jobTimezone ?? companyTimezone ?? null;
			_timezoneSourceType = !!jobTimezone ? TimeZoneSourceType.JOB : TimeZoneSourceType.COMPANY;

			setTimezone(_timezone);
			setTimezoneSourceType(_timezoneSourceType);
		};
		getTimezone();
	}, [companyTimezone, findTimezone, jobTimezone, latitude, longitude]);

	return (
		< TimezoneSourceBanner
			timezoneInUse={timezone}
			timezoneSourceType={timezoneSourceType}
		/>
	);
};

function mapDispatchToProps() {
	return {
		findTimezone: TimezoneActions.find,
	};
}

const connector = connect(null, mapDispatchToProps());

const enhance = compose<React.ComponentType<OwnProps>>(
	connector,
	React.memo
);

export default enhance(TimezoneHeader);
